import React, { FunctionComponent, useEffect, useState } from 'react'

import { IProps } from './interface/IProps'
import {
  DotPulse,
  ProcessedText,
  Progress,
  ProgressBarContainer,
  Title,
} from './style'

export const BatchLoader: FunctionComponent<IProps> = ({
  status,
  processed,
  total,
}) => {
  const [progressBar, setProgressBar] = useState<number>(0)
  const processedPercentage =
    processed === Number(0) ||
    total === Number(0) ||
    isNaN(processed) ||
    isNaN(total)
      ? 0
      : (processed / total) * 100

  useEffect(() => {
    setProgressBar((processed / total) * 100)
  }, [processed, total])
  return (
    <ProgressBarContainer>
      <Title>{status.charAt(0).toUpperCase() + status.slice(1)}</Title>
      <DotPulse />
      <ProcessedText>
        {processed} / {total}
      </ProcessedText>
      <Progress
        processed={processedPercentage}
        total={total}
        progressBar={progressBar}
      />
    </ProgressBarContainer>
  )
}
